import * as React from "react";
import {Icon, Tag, Tooltip} from "antd";
import Label from "./Label";
import {EmailContact} from "../api/dtos/dtos";
import locales from "../locales";
import {copyLink} from "../utils/copy-utils";

interface Props {
  contact: EmailContact;
  link?: string;
}

class EmailContactTag extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {contact, link} = this.props;

    return (
      <Tag key={String(contact.id)} title={contact.name}>
        {contact.email
          ? <>{contact.name}<Label style={{marginRight: 0}} value={`(${contact.email})`}/></>
          : contact.name
        }
        {link &&
            <Tooltip title={locales.copy_link}>
                <Icon
                    type={'copy'}
                    style={{marginLeft: 4}}
                    onClick={this.onCopy}
                />
            </Tooltip>
        }
      </Tag>
    );
  }

  private onCopy = async () => {
    const { link } = this.props;
    if (!link) {
      return;
    }

    await copyLink(link);
  };
}

export default EmailContactTag;


// WEBPACK FOOTER //
// ./src/common/EmailContactTag.tsx